<div class="col-xs-8 col-md-8 col-centered col-slider no-padding row" *ngIf="!legalEntity.isLoaded">
    <div class="small text-center">загрузка...</div>
</div>
<legal-entity-form *ngIf="legalEntity.isLoaded" [legalEntity]="legalEntity"></legal-entity-form>
